import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'utils/contexts/auth-context';

interface IProtectedRoute {
  redirectPath?: string;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<IProtectedRoute> = ({
  redirectPath = '/login',
  children,
}) => {
  const { isLoggedIn, loading } = useAuth();

  if (!loading && !isLoggedIn) return <Navigate to={redirectPath} replace />;
  return children as React.ReactElement<any, any>;
};

export default ProtectedRoute;
